import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { pinnedJobsQueryKey } from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import {
  DeleteRequisitionOwnerRequest,
  HttpResponse,
  RequisitionOwner,
} from "@/types";

export function useDeleteRequisitionOwner() {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({
      deleteRequisitionOwnerRequest,
    }: {
      deleteRequisitionOwnerRequest: DeleteRequisitionOwnerRequest;
    }) => {
      // TODO STF-176: Cleanup paths for delete and create requisition owners. Create and Delete should not be so different.
      const path = `requisition-owners/requisition/${deleteRequisitionOwnerRequest.requisitionId.toString()}/user/${deleteRequisitionOwnerRequest.userId.toString()}`;
      const res = await guacHttpClient.delete<
        RequisitionOwner,
        HttpResponse<RequisitionOwner>
      >(path);

      return res.data;
    },
    onSuccess: () => {
      // Invalidate queries that have job intake
      void queryClient.invalidateQueries({
        queryKey: ["jobs", currentCompanyId],
      });
      // Removing a req owner can unpin the job on the backend (their last
      // active req on it) — refetch so the sidebar drops it immediately.
      void queryClient.invalidateQueries({ queryKey: pinnedJobsQueryKey });
    },
  });

  return mutation;
}
